module.exports = __webpack_public_path__ + "public/img/wx.046e995e.png";